import React ,{ Component} from "react";
import './ImageComponent.css'
import { Dialog } from "@reach/dialog";
import "@reach/dialog/styles.css";


 class ImageComponent extends Component {

    constructor(props) {
        super(props);
        this.setState({ showDialog: false });
    }
    handleShowDialog = () => {
        this.setState({ showDialog: true });
    }
    closeDialog() {
        this.setState({ showDialog: false });
    }
    render() {
        return (
            <div>
                <img id="myImg" class="tiles-list-img-img" onClick={this.handleShowDialog.bind(this)} src={this.props.ImageUrl} alt="" />
                {
                    this.state &&
                    <Dialog isOpen={this.state.showDialog} class="modal">
                         <span class="close" onClick={this.closeDialog.bind(this)}>&times; </span>
                        <img alt="" class="modal-content" id="img01" src={this.props.ImageUrl} />
                        {/* <button onClick={this.closeDialog.bind(this)}>Okay</button> */}
                    </Dialog>

                }
            </div>
        );
    }
}
export default ImageComponent;